/**
 * „Wyślij ponownie" — a fresh invitation e-mail for an invitation still waiting.
 *
 * Promoted out of `pages/client-roster/lib/useClientRoster.ts` on 24 September 2026, when the
 * `invitationPending` task card became its second caller. The roster's actions menu and the card
 * both ask `entities/client`'s `canResendInvitation` first: `ResendInvitationEmailAsync` refuses
 * unless the person the invitation names is still `Invited`, which an invited roster ENTRY is and
 * an offer to an existing account never is (client-onboarding R6).
 *
 * The offer's fourteen days do NOT restart (client-onboarding R4/R5) — a resend mints a fresh mail
 * token and leaves the deadline where the trainer's seat was committed to it — so nothing here is
 * invalidated: no read this app makes changes.
 *
 * A promise, rejecting on a refusal. The caller says it.
 */

import { useMutation } from '@tanstack/react-query';

import { postCustomerInvitationsInvitationIdResendEmail } from '~/shared/api/generated/endpoints/customer/customer';

export interface InvitationResend {
  readonly resendInvitation: (invitationId: number) => Promise<void>;
}

export function useResendInvitation(): InvitationResend {
  const resend = useMutation({
    mutationFn: (invitationId: number) => postCustomerInvitationsInvitationIdResendEmail(invitationId),
  });

  return {
    resendInvitation: async (invitationId) => {
      await resend.mutateAsync(invitationId);
    },
  };
}
